<template>
  <div class="sign_exam">
    <div class="sign_level">
      <h4><b>*</b>难易程度：</h4>
      <div class="sign_radio">
        <el-radio v-model="radio" label="1">简单</el-radio>
        <el-radio v-model="radio" label="2">一般</el-radio>
        <el-radio v-model="radio" label="3">较难</el-radio>
        <el-radio v-model="radio" label="4">困难</el-radio>
      </div>
    </div>
    <div class="sign_title">
      <h4><b>*</b>题目：</h4>
      <el-input
        placeholder="请输入试题题目"
        type="textarea"
        :rows="2"
        v-model="signTitle"
        class="signTextarea"
        resize="none"
      ></el-input>
      <div class="add_xx add_titleK" @click="add_answer()">
        <i class="el-icon-plus"></i><span class="add_answer">插入空</span>
      </div>
      <div class="clear"></div>
      <div class="answer_ds">
        小贴士：右上角<b>'填入空'</b>,在{}内填写正确答案，多个备案答案用“|”隔开
      </div>
    </div>
    <div class="clear"></div>
    <div class="sign_know">
      <span>知识点：</span>
      <button v-show="showbtn" @click="showKonw">
        <i class="el-icon-plus"></i><span class="add_answer">知识点</span>
      </button>
      <el-input v-model="konws" v-show="konwshow"></el-input>
    </div>
    <div class="sign_analysis">
      <span>答案解析：</span>
      <el-input
        type="textarea"
        :rows="2"
        resize="none"
        placeholder="请输入内容"
        v-model="textarea"
      >
      </el-input>
    </div>
    <div class="btn_up">
      <el-button type="primary" @click="upExam">提交</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "tfai",
  data() {
    return {
      radio: "1",
      imageUrl: "",
      konwshow: false,
      konws: "",
      showbtn: true,
      qid: this.$route.query.q_id,
      id: this.$route.query.id,
      url: this.HOME,
      textarea: "",
      signTitle: "",
    };
  },
  methods: {
    showKonw() {
      this.showbtn = false;
      this.konwshow = true;
    },
    add_answer() {
      this.signTitle = this.signTitle + "{}";
    },
    upExam() {
      var answerList = [];
      if (this.id) {
        var data = {
          id: this.id,
          level: this.radio,
          questions: this.signTitle,
          type: 3,
          score: 10,
          parsing_answer: this.textarea,
          knowledge: this.konws,
          service: "Question.QsnUpdate",
          userid: localStorage.getItem("userid"),
        };
      } else {
        var data = {
          e_id: this.qid,
          level: this.radio,
          questions: this.signTitle,
          type: 3,
          score: 10,
          parsing_answer: this.textarea,
          knowledge: this.konws,
          service: "Question.QsnAdd",
          userid: localStorage.getItem("userid"),
        };
      }

      this.$axios
        .post(this.url, this.$qs.stringify(data))
        .then((res) => {
          if (res.data.data.code == 0) {
            this.alertView.successView("数据提交成功");
            this.$router.push({ path: "/detail/", query: { id: this.qid } });
          } else {
            this.alertView.failView(res.data.data.msg);
          }
        })
        .catch(function (error) {
          // 请求失败处理
          this.alertView.failView(res.data.data.msg);
        });
    },
  },
  mounted() {
    if (this.id) {
      var List = {
        service: "Question.QsnEdit",
        qid: this.id,
      };
      var data = [];
      var corarr = [];
      let letterArr = [];
      for (var i = 65; i < 91; i++) {
        letterArr.push(String.fromCharCode(i));
      }
      {
        this.$axios.post(this.HOME, this.$qs.stringify(List)).then((res) => {
          this.signTitle = res.data.data.questions;
          if (res.data.data.knowledge) {
            this.showbtn = false;
            this.konwshow = true;
            this.konws = res.data.data.knowledge;
          }
          this.textarea = res.data.data.parsing_answer;
        });
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/examView/exercise.vue